require('./helpers/bundle-manifest').register(JSON.parse("{\"3VcRJ\":\"venue-filter-script.js\",\"6brh7\":\"venue-filter-worker.18ed20a1.js\"}"));